import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/I18nContext';

const NotFoundWrapper = styled.div`
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 24px;
  background-color: #FDFBF7;
  text-align: center;
  position: relative;
  overflow: hidden;
`;

const ErrorCode = styled.h1`
  font-family: 'Constantia', var(--font-heading), 'Times New Roman', serif;
  font-size: clamp(120px, 25vw, 300px);
  font-weight: 700;
  color: #183029;
  margin: 0;
  line-height: 1;
  opacity: 0.03;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  user-select: none;
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
`;

const GoldDivider = styled.div`
  width: 40px;
  height: 2px;
  background-color: #B9975B;
  margin-bottom: 32px;
`;

const Title = styled.h2`
  font-family: 'Constantia', var(--font-heading), 'Times New Roman', serif;
  font-size: clamp(32px, 5vw, 48px);
  color: #183029;
  margin: 0 0 24px 0;
  font-weight: 700;
`;

const Description = styled.p`
  font-family: 'Montserrat', var(--font-body), sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #3D4F47;
  margin: 0 0 40px 0;
`;

const HomeButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 36px;
  background-color: #183029;
  color: #DFD8C7;
  font-family: 'Montserrat', var(--font-body), sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 4px;
  transition: all var(--transition-fast);

  &:hover {
    background-color: #B9975B;
    color: #183029;
    transform: translateY(-2px);
  }
`;

const NotFound = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // We try to fetch the translation, but provide a fallback string just in case
    document.title = (t('notfound.title') || '404') + " — Terra Brasilis";
  }, [t]);

  return (
    <NotFoundWrapper>
      <ErrorCode>404</ErrorCode>
      <ContentContainer>
        <Fade direction="up" cascade damping={0.2} triggerOnce>
          <GoldDivider />
          <Title>{t('notfound.heading') || 'Página no encontrada'}</Title>
          <Description>{t('notfound.description') || 'La página que buscas no existe o ha sido movida.'}</Description>
          <HomeButton to="/">{t('notfound.btn_home') || 'Volver al inicio'}</HomeButton>
        </Fade>
      </ContentContainer>
    </NotFoundWrapper>
  );
};

export default NotFound;
